<template>
  <div
    class="p-fluid"
  >
    <br />

    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="sQuoteNo">Quote No</label>
        <InputText 
          class="clearer"
          id="sQuoteNo" 
          :disabled="true" 
          v-model.trim="quotation.sQuoteNo" 
        />
      </div>
      <div class="p-field p-col">
        <label for="versionNo">Version No</label>
        <InputText
          class="clearer"
          id="versionNo"
          v-model.trim="quotation.versionNo"
          required="true"
          :disabled="true" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="opportunity">Enquiry</label>
        <InputText 
          class="clearer"
          id="oppDescription" 
          :disabled="true" 
          v-model.trim="thisOpportunity.oppDescription" 
        />
      </div>
      <div class="p-field p-col">
        <label for="customer">Customer</label>
        <InputText 
          class="clearer"
          id="customerName" 
          :disabled="true" 
          v-model.trim="customerName" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="mbpBranch">Branch *</label>
        <div v-if="quotation.mbpBranch">
          <InputText 
            class="clearer"
            id="mbpBranch" 
            :disabled="true" 
            v-model.trim="quotation.mbpBranch.branchName" 
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-field p-col">
        <label for="quoteVerDateMoment">Quote Date*</label>
        <Calendar
          class="clearer"
          id="icon1"
          v-model="quotation.quoteVerDate"
          dateFormat="dd/mm/yy"
          :showIcon="true"
          :disabled="true" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="productValue">Product Value to Customer</label>
        <InputNumber 
          class="clearer"
          id="productValue"
          v-model.trim="quotation.productValue"
          required="false"
          :disabled="true" 
        />
      </div>
      <div class="p-field p-col">
        <label for="internalValue">Internal Value (optional)</label>
        <InputNumber 
          class="clearer"
          id="internalValue" 
          v-model.trim="quotation.internalValue" 
          required="false"
          :disabled="true" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="productQty">Product Qty</label>
        <InputNumber 
          class="clearer"
          id="productQty"
          v-model.trim="quotation.productQty"
          required="false"
          :disabled="true" 
        />
      </div>
      <div class="p-field p-col">
        <label for="chaseBy">Chase By</label>
        <div v-if="quotation.chaseBy">
          <InputText
            class="clearer"
            id="chaseBy"
            v-model="quotation.chaseBy.fullName"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="quoteGrade">Quotation Grade</label>
        <div v-if="quotation.quoteGrade">
          <InputText
            class="clearer"
            id="quoteGrade"
            v-model="quotation.quoteGrade.quoteGradeName"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-field p-col">
        <label for="expOrderDateMoment">Expiry Order Date*</label>
        <InputText
          class="clearer"
          id="expiryDate"
          v-model.trim="quotation.expiryDate"
          required="true"
          :disabled="true" 
          autofocus
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="expOrderDateMoment">Expected Order Date (optional)</label>
        <Calendar
          class="clearer"
          id="icon2"
          v-model="quotation.expectedOrderDate"
          dateFormat="dd/mm/yy"
          :showIcon="true"
          :disabled="true" 
        />
      </div>
      <div class="p-field p-col">
        <label for="reqDeliveryDateMoment">Req. Deliv. Date (optional)</label>
        <Calendar
          class="clearer"
          id="icon4"
          v-model="quotation.reqDeliveryDate"
          dateFormat="dd/mm/yy"
          :showIcon="true"
          :disabled="true" 
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="custRef">Status Comment</label>
        <InputText
          class="clearer"
          id="statusComment"
          v-model.trim="quotation.statusComment"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="manufacturer">Manufacturer *</label>
        <div v-if="quotation.wonManufacturer">
          <InputText
            class="clearer"
            id="manufacturer"
            v-model="quotation.wonManufacturer.manufacturerName"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>

    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col" v-if="(quotation && quotation.quoteStatus && quotation.quoteStatus.statusName === 'Lost') || quotation && quotation.quoteStatus && (quotation.quoteStatus.statusName === 'Cancelled' || quotation.quoteStatus.statusName === 'Won')">
        <div v-if="quotation && quotation.quoteStatus && quotation.quoteStatus.statusName === 'Lost'">
          <label for="lostQuoteReason">Lost Quote Reason</label>
          <div v-if="quotation.lostQuoteReason">
            <InputText
              class="clearer"
              id="lostQuoteReason"
              v-model="quotation.lostQuoteReason.lqNoteDesc"
              :disabled="true"
            />
          </div>
          <div v-else>
            <InputText
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>
        <div v-else-if="quotation && quotation.quoteStatus && (quotation.quoteStatus.statusName === 'Cancelled' || quotation.quoteStatus.statusName === 'Won')">
          <label for="statusComment">Won/Lost Comment</label>
          <InputText
            class="clearer"
            id="statusComment"
            v-model.trim="quotation.statusComment"
            :disabled="true" 
            autofocus
          />
        </div>
      </div>
      <div class="p-field p-col">
        <label for="quoteType.typeName">Product Type *</label>
        <div v-if="quotation.productType">
          <InputText
            class="clearer"
            id="productType"
            v-model="quotation.productType.productTypeName"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="notes">Notes (optional)</label>
        <Textarea
          class="clearer"
          rows="2" 
          :autoResize="true" 
          id="notes"
          v-model.trim="quotation.notes"
          required="false"
          autofocus
          :disabled="true" 
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="createdBy">Booked By:</label>
        <InputText
          v-if="quotation.createdBy"
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="quotation.createdBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="created">Booked Date:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="quotation.dateCreated"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="updatedBy">Booking Updated By:</label>
        <InputText
          v-if="quotation.updatedBy"
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="quotation.updatedBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="updated">Booking Date Updated:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="quotation.dateUpdated"
        ></InputText>
      </div>
    </div>

  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import QuotationService from "@/service/QuotationService";
import SettingService from "@/service/SettingService";
import CustomerService from "@/service/CustomerService";

export default {
  data: () => ({
    settingService: new SettingService(),
    quotationService: new QuotationService(),
    opportunityService: new OpportunityService(),
    customerService: new CustomerService(),
    quotationKey: 0,
    activeQuote: false,
    customerName: '',
    thisOpportunity: {}
  }),
  computed: {
    quotation() {
      let a = this.$store.getters['quotations/getQuoteForTabs']
      if (a && a.customer)
        this.customerName = a.customer.custName
      if (a.opportunity)
        this.thisOpportunity = a.opportunity
      return a
    }
  },
  watch: {
    quotation(val) { 
      
      if (val) {
        if (val.productValue) {
          try {
            if (val.productValue.substring(0, 1) === '£') {
              this.quotation.productValue = val.productValue.substring(1, val.productValue.length)
            }
          } catch(e) {}
        } 
        this.quotationKey++
      }
    }
  }
}
</script>

<style>

</style>